// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.adminCompanyListContainer {
  padding: 20px;
}

/* 필터 영역 */
.adminFilterSection {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}

.filterItem {
  display: flex;
  flex-direction: column; /* 수직 방향으로 배치 변경 */
  align-items: flex-start; /* 왼쪽 정렬 */
}

.filterLabel {
  margin-bottom: 8px; /* 레이블과 컨트롤 사이 간격 */
  font-size: 14px;
  font-weight: normal;
}

/* 드롭다운 스타일 수정 */
.dropdownWrapper {
  position: relative;
  width: 270px; /* 드롭박스 너비 270px로 고정 */
}

.dropdownField {
  width: 100%;
  height: 45px; /* 높이 45px로 고정 */
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 15px; /* 패딩 조정 */
  border: 1px solid #ccc;
  border-radius: 4px;
  cursor: pointer;
  box-sizing: border-box; /* 테두리와 패딩을 너비/높이에 포함 */
  font-size: 15px;
}

.arrowIcon {
  font-size: 10px;
  color: #666;
}

/* 검색 영역 스타일 수정 */
.searchWrapper {
  position: relative;
  width: 215px; /* 검색창 너비 215px로 고정 */
}

.searchInput {
  width: 100%;
  height: 45px; /* 높이 45px로 고정 */
  padding: 0 40px 0 15px; /* 패딩 조정 */
  border: 1px solid #ccc;
  border-radius: 25px;
  box-sizing: border-box; /* 테두리와 패딩을 너비/높이에 포함 */
  font-size: 15px;
}

.searchButton {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
}

/* 총 레코드 수 */
.totalRecords {
  margin: 10px 0;
  font-size: 14px;
}

/* 테이블 스타일 */
.tableContainer {
  overflow-x: auto;
  margin-bottom: 20px;
  box-shadow: none;
}

.dataTable {
  width: 100%;
  border-collapse: collapse;
  border: none;
  table-layout: fixed;
}

/* 인덱스, 접속허용, 삭제 열 너비 동일하게 설정 */
.dataTable th:first-child,
.dataTable td:first-child,
.dataTable th:nth-last-child(2), /* 접속허용 열 */
.dataTable td:nth-last-child(2),
.dataTable th:last-child, /* 삭제 열 */
.dataTable td:last-child {
  width: 8%; /* 좁은 너비 설정 */
}

/* 나머지 열들은 균등하게 배분 */
.dataTable th:not(:first-child):not(:nth-last-child(2)):not(:last-child),
.dataTable td:not(:first-child):not(:nth-last-child(2)):not(:last-child) {
  width: 15.2%; /* (100% - (8% × 3개 열)) / 5개 열 = 15.2% */
}

/* 헤더 스타일 수정 - 테두리 색상 검정색으로 변경 */
.dataTable th {
  padding: 15px 10px;
  text-align: center;
  border: none;
  border-top: 2px solid black; /* 상단 테두리 색상 검정색으로 변경 */
  border-bottom: 2px solid black; /* 하단 테두리 색상 검정색으로 변경 */
  font-weight: normal;
  background-color: white !important;
}

/* 데이터 셀 스타일 */
.dataTable td {
  padding: 15px 10px;
  text-align: center;
  border: none;
  background-color: white !important; /* 강제로 흰색 배경 적용 */
}

/* 모든 행(tr)에 흰색 배경 적용 */
.dataTable tr {
  background-color: white !important;
}

/* 첫 번째 열(Index) 셀 스타일 */
.dataTable td:first-child {
  background-color: white !important; /* Index 열의 배경색을 흰색으로 강제 지정 */
}

/* 컬럼 사이의 구분선 제거 */
.dataTable th:not(:last-child),
.dataTable td:not(:last-child) {
  border-right: none;
}

/* 페이지네이션 스타일 업데이트 - 화면 아래쪽으로 이동 */
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 100px; /* 테이블과의 간격을 크게 늘림 */
  margin-bottom: 30px;
  padding-bottom: 20px; /* 하단 여백 추가 */
  position: relative; /* 상대 위치 지정 */
}

.pageNumber, .pageNav {
  min-width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 5px;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 14px;
}

.pageNumber {
  color: #333; /* 일반 페이지 번호 색상 */
}

.pageNumber.active {
  color: #FF6F0F; /* 현재 페이지 오렌지색으로 강조 */
  font-weight: bold;
}

.pageNav {
  color: #FF6F0F; /* 화살표 오렌지색으로 설정 */
  font-size: 16px; /* 화살표 크기 약간 키움 */
}

/* 필터 섹션 스타일 수정 */
.filterSection {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}

.filterLeft, .filterRight {
  display: flex;
  align-items: flex-end; /* 아래쪽 정렬 */
  gap: 20px; /* 요소 간 간격 */
}

.filterItem {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.filterLabel {
  margin-bottom: 8px;
  font-size: 14px;
}

/* 접속허용 여부 체크박스 스타일 */
.accessToggleContainer {
  display: flex;
  align-items: center;
  margin-right: 20px;
}

.accessToggleLabel {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
}

.accessToggleCheckbox, .accessCheckbox {
  width: 18px;
  height: 18px;
  cursor: pointer;
}

/* 테이블 열 스타일 */
.accessColumn, .deleteColumn {
  text-align: center;
}

.accessCheckbox {
  margin: 0 auto;
  display: block;
  width: 18px;
  height: 18px;
  cursor: pointer;
}

.deleteButton {
  margin: 0 auto;
  display: block;
  background: none;
  border: none;
  cursor: pointer;
  padding: 5px;
}

.deleteButton:hover svg path {
  fill: #ff0000; /* 호버 시 빨간색으로 변경 */
}

/* 업체명 링크 스타일 수정 */
.companyNameLink {
  color: #000000; /* 텍스트 색상을 검정색으로 변경 */
  cursor: pointer;
  text-decoration: none; /* 기본 상태에서는 밑줄 없음 */
  transition: all 0.2s ease; /* 부드러운 전환 효과 */
}

.companyNameLink:hover {
  color: #000000; /* 호버 시에도 검정색 유지 */
  text-decoration: underline; /* 호버 시 밑줄 표시 */
  font-weight: bold; /* 호버 시 텍스트 굵게 */
}

/* 드롭다운 스타일 */
.dropdown-container {
  position: relative;
  width: 210px;
}

.dropdown-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 15px;
  border: 1px solid #ccc;
  border-radius: 10px;
  background-color: #f9f9f9;
  cursor: pointer;
  font-size: 16px;
}

.arrow-icon {
  transition: transform 0.3s;
  font-size: 12px;
}

.arrow-icon.down {
  transform: rotate(180deg);
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  max-height: 250px;
  overflow-y: auto;
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 10px;
  margin-top: 5px;
  z-index: 100;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.dropdown-item {
  padding: 12px 15px;
  cursor: pointer;
}

.dropdown-item:hover {
  background-color: #f0f0f0;
}

.dropdown-item.selected {
  background-color: #e1e8ff; /* 파란색 배경 (스크린샷과 유사) */
}

/* 스크롤바 스타일 */
.dropdown-menu::-webkit-scrollbar {
  width: 6px;
}

.dropdown-menu::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.dropdown-menu::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 10px;
}

.dropdown-menu::-webkit-scrollbar-thumb:hover {
  background: #aaa;
}

.list-controls {
  margin-bottom: 20px;
  display: flex;
  align-items: flex-start;
}

/* 접속허용 체크박스 스타일 */
.access-column {
  text-align: center;
}

.access-checkbox {
  width: 18px;
  height: 18px;
  cursor: pointer;
}

/* 삭제 버튼 스타일 수정 - 호버 효과 제거 */
.delete-column {
  text-align: center;
}

.delete-button {
  background-color: white;
  color: black;
  border: 1px solid #ccc;
  padding: 5px 10px;
  border-radius: 4px;
  cursor: pointer;
}

/* 테이블 스타일 */
.companies-table {
  width: 100%;
  border-collapse: collapse;
}

.companies-table th,
.companies-table td {
  padding: 12px;
  text-align: left;
  border-bottom: 1px solid #ddd;
}

.companies-table th {
  background-color: #f9f9f9;
  font-weight: bold;
}

.companies-table tr:hover {
  background-color: #f5f5f5;
}

.company-link {
  color: #000;
  text-decoration: none;
}

.company-link:hover {
  text-decoration: underline;
  font-weight: bold;
} `, "",{"version":3,"sources":["webpack://./src/styles/admin/AdminCompanyList.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA,UAAU;AACV;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB,EAAE,kBAAkB;EAC1C,uBAAuB,EAAE,UAAU;AACrC;;AAEA;EACE,kBAAkB,EAAE,mBAAmB;EACvC,eAAe;EACf,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,YAAY,EAAE,sBAAsB;AACtC;;AAEA;EACE,WAAW;EACX,YAAY,EAAE,gBAAgB;EAC9B,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe,EAAE,UAAU;EAC3B,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,sBAAsB,EAAE,uBAAuB;EAC/C,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,YAAY,EAAE,qBAAqB;AACrC;;AAEA;EACE,WAAW;EACX,YAAY,EAAE,gBAAgB;EAC9B,sBAAsB,EAAE,UAAU;EAClC,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB,EAAE,uBAAuB;EAC/C,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;AAEA,YAAY;AACZ;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,YAAY;AACZ;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;AACrB;;AAEA,+BAA+B;AAC/B;;;;;;EAME,SAAS,EAAE,aAAa;AAC1B;;AAEA,oBAAoB;AACpB;;EAEE,YAAY,EAAE,wCAAwC;AACxD;;AAEA,gCAAgC;AAChC;EACE,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,2BAA2B,EAAE,uBAAuB;EACpD,8BAA8B,EAAE,uBAAuB;EACvD,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA,cAAc;AACd;EACE,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,kCAAkC,EAAE,iBAAiB;AACvD;;AAEA,uBAAuB;AACvB;EACE,kCAAkC;AACpC;;AAEA,wBAAwB;AACxB;EACE,kCAAkC,EAAE,6BAA6B;AACnE;;AAEA,kBAAkB;AAClB;;EAEE,kBAAkB;AACpB;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB,EAAE,oBAAoB;EACvC,mBAAmB;EACnB,oBAAoB,EAAE,aAAa;EACnC,kBAAkB,EAAE,aAAa;AACnC;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,WAAW,EAAE,iBAAiB;AAChC;;AAEA;EACE,cAAc,EAAE,qBAAqB;EACrC,iBAAiB;AACnB;;AAEA;EACE,cAAc,EAAE,kBAAkB;EAClC,eAAe,EAAE,iBAAiB;AACpC;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB,EAAE,WAAW;EAClC,SAAS,EAAE,YAAY;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA,cAAc;AACd;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa,EAAE,kBAAkB;AACnC;;AAEA,kBAAkB;AAClB;EACE,cAAc,EAAE,qBAAqB;EACrC,eAAe;EACf,qBAAqB,EAAE,mBAAmB;EAC1C,yBAAyB,EAAE,eAAe;AAC5C;;AAEA;EACE,cAAc,EAAE,kBAAkB;EAClC,0BAA0B,EAAE,eAAe;EAC3C,iBAAiB,EAAE,gBAAgB;AACrC;;AAEA,aAAa;AACb;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB,EAAE,sBAAsB;AACnD;;AAEA,aAAa;AACb;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;AACzB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,YAAY;AACZ;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,aAAa;EACb,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;AACnB","sourcesContent":[".adminCompanyListContainer {\n  padding: 20px;\n}\n\n/* 필터 영역 */\n.adminFilterSection {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 20px;\n}\n\n.filterItem {\n  display: flex;\n  flex-direction: column; /* 수직 방향으로 배치 변경 */\n  align-items: flex-start; /* 왼쪽 정렬 */\n}\n\n.filterLabel {\n  margin-bottom: 8px; /* 레이블과 컨트롤 사이 간격 */\n  font-size: 14px;\n  font-weight: normal;\n}\n\n/* 드롭다운 스타일 수정 */\n.dropdownWrapper {\n  position: relative;\n  width: 270px; /* 드롭박스 너비 270px로 고정 */\n}\n\n.dropdownField {\n  width: 100%;\n  height: 45px; /* 높이 45px로 고정 */\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 15px; /* 패딩 조정 */\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  cursor: pointer;\n  box-sizing: border-box; /* 테두리와 패딩을 너비/높이에 포함 */\n  font-size: 15px;\n}\n\n.arrowIcon {\n  font-size: 10px;\n  color: #666;\n}\n\n/* 검색 영역 스타일 수정 */\n.searchWrapper {\n  position: relative;\n  width: 215px; /* 검색창 너비 215px로 고정 */\n}\n\n.searchInput {\n  width: 100%;\n  height: 45px; /* 높이 45px로 고정 */\n  padding: 0 40px 0 15px; /* 패딩 조정 */\n  border: 1px solid #ccc;\n  border-radius: 25px;\n  box-sizing: border-box; /* 테두리와 패딩을 너비/높이에 포함 */\n  font-size: 15px;\n}\n\n.searchButton {\n  position: absolute;\n  right: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n  background: none;\n  border: none;\n  cursor: pointer;\n}\n\n/* 총 레코드 수 */\n.totalRecords {\n  margin: 10px 0;\n  font-size: 14px;\n}\n\n/* 테이블 스타일 */\n.tableContainer {\n  overflow-x: auto;\n  margin-bottom: 20px;\n  box-shadow: none;\n}\n\n.dataTable {\n  width: 100%;\n  border-collapse: collapse;\n  border: none;\n  table-layout: fixed;\n}\n\n/* 인덱스, 접속허용, 삭제 열 너비 동일하게 설정 */\n.dataTable th:first-child,\n.dataTable td:first-child,\n.dataTable th:nth-last-child(2), /* 접속허용 열 */\n.dataTable td:nth-last-child(2),\n.dataTable th:last-child, /* 삭제 열 */\n.dataTable td:last-child {\n  width: 8%; /* 좁은 너비 설정 */\n}\n\n/* 나머지 열들은 균등하게 배분 */\n.dataTable th:not(:first-child):not(:nth-last-child(2)):not(:last-child),\n.dataTable td:not(:first-child):not(:nth-last-child(2)):not(:last-child) {\n  width: 15.2%; /* (100% - (8% × 3개 열)) / 5개 열 = 15.2% */\n}\n\n/* 헤더 스타일 수정 - 테두리 색상 검정색으로 변경 */\n.dataTable th {\n  padding: 15px 10px;\n  text-align: center;\n  border: none;\n  border-top: 2px solid black; /* 상단 테두리 색상 검정색으로 변경 */\n  border-bottom: 2px solid black; /* 하단 테두리 색상 검정색으로 변경 */\n  font-weight: normal;\n  background-color: white !important;\n}\n\n/* 데이터 셀 스타일 */\n.dataTable td {\n  padding: 15px 10px;\n  text-align: center;\n  border: none;\n  background-color: white !important; /* 강제로 흰색 배경 적용 */\n}\n\n/* 모든 행(tr)에 흰색 배경 적용 */\n.dataTable tr {\n  background-color: white !important;\n}\n\n/* 첫 번째 열(Index) 셀 스타일 */\n.dataTable td:first-child {\n  background-color: white !important; /* Index 열의 배경색을 흰색으로 강제 지정 */\n}\n\n/* 컬럼 사이의 구분선 제거 */\n.dataTable th:not(:last-child),\n.dataTable td:not(:last-child) {\n  border-right: none;\n}\n\n/* 페이지네이션 스타일 업데이트 - 화면 아래쪽으로 이동 */\n.pagination {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 100px; /* 테이블과의 간격을 크게 늘림 */\n  margin-bottom: 30px;\n  padding-bottom: 20px; /* 하단 여백 추가 */\n  position: relative; /* 상대 위치 지정 */\n}\n\n.pageNumber, .pageNav {\n  min-width: 30px;\n  height: 30px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin: 0 5px;\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 14px;\n}\n\n.pageNumber {\n  color: #333; /* 일반 페이지 번호 색상 */\n}\n\n.pageNumber.active {\n  color: #FF6F0F; /* 현재 페이지 오렌지색으로 강조 */\n  font-weight: bold;\n}\n\n.pageNav {\n  color: #FF6F0F; /* 화살표 오렌지색으로 설정 */\n  font-size: 16px; /* 화살표 크기 약간 키움 */\n}\n\n/* 필터 섹션 스타일 수정 */\n.filterSection {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 20px;\n}\n\n.filterLeft, .filterRight {\n  display: flex;\n  align-items: flex-end; /* 아래쪽 정렬 */\n  gap: 20px; /* 요소 간 간격 */\n}\n\n.filterItem {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n.filterLabel {\n  margin-bottom: 8px;\n  font-size: 14px;\n}\n\n/* 접속허용 여부 체크박스 스타일 */\n.accessToggleContainer {\n  display: flex;\n  align-items: center;\n  margin-right: 20px;\n}\n\n.accessToggleLabel {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 14px;\n}\n\n.accessToggleCheckbox, .accessCheckbox {\n  width: 18px;\n  height: 18px;\n  cursor: pointer;\n}\n\n/* 테이블 열 스타일 */\n.accessColumn, .deleteColumn {\n  text-align: center;\n}\n\n.accessCheckbox {\n  margin: 0 auto;\n  display: block;\n  width: 18px;\n  height: 18px;\n  cursor: pointer;\n}\n\n.deleteButton {\n  margin: 0 auto;\n  display: block;\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 5px;\n}\n\n.deleteButton:hover svg path {\n  fill: #ff0000; /* 호버 시 빨간색으로 변경 */\n}\n\n/* 업체명 링크 스타일 수정 */\n.companyNameLink {\n  color: #000000; /* 텍스트 색상을 검정색으로 변경 */\n  cursor: pointer;\n  text-decoration: none; /* 기본 상태에서는 밑줄 없음 */\n  transition: all 0.2s ease; /* 부드러운 전환 효과 */\n}\n\n.companyNameLink:hover {\n  color: #000000; /* 호버 시에도 검정색 유지 */\n  text-decoration: underline; /* 호버 시 밑줄 표시 */\n  font-weight: bold; /* 호버 시 텍스트 굵게 */\n}\n\n/* 드롭다운 스타일 */\n.dropdown-container {\n  position: relative;\n  width: 210px;\n}\n\n.dropdown-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 15px;\n  border: 1px solid #ccc;\n  border-radius: 10px;\n  background-color: #f9f9f9;\n  cursor: pointer;\n  font-size: 16px;\n}\n\n.arrow-icon {\n  transition: transform 0.3s;\n  font-size: 12px;\n}\n\n.arrow-icon.down {\n  transform: rotate(180deg);\n}\n\n.dropdown-menu {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  width: 100%;\n  max-height: 250px;\n  overflow-y: auto;\n  background-color: white;\n  border: 1px solid #ccc;\n  border-radius: 10px;\n  margin-top: 5px;\n  z-index: 100;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n}\n\n.dropdown-item {\n  padding: 12px 15px;\n  cursor: pointer;\n}\n\n.dropdown-item:hover {\n  background-color: #f0f0f0;\n}\n\n.dropdown-item.selected {\n  background-color: #e1e8ff; /* 파란색 배경 (스크린샷과 유사) */\n}\n\n/* 스크롤바 스타일 */\n.dropdown-menu::-webkit-scrollbar {\n  width: 6px;\n}\n\n.dropdown-menu::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 10px;\n}\n\n.dropdown-menu::-webkit-scrollbar-thumb {\n  background: #ccc;\n  border-radius: 10px;\n}\n\n.dropdown-menu::-webkit-scrollbar-thumb:hover {\n  background: #aaa;\n}\n\n.list-controls {\n  margin-bottom: 20px;\n  display: flex;\n  align-items: flex-start;\n}\n\n/* 접속허용 체크박스 스타일 */\n.access-column {\n  text-align: center;\n}\n\n.access-checkbox {\n  width: 18px;\n  height: 18px;\n  cursor: pointer;\n}\n\n/* 삭제 버튼 스타일 수정 - 호버 효과 제거 */\n.delete-column {\n  text-align: center;\n}\n\n.delete-button {\n  background-color: white;\n  color: black;\n  border: 1px solid #ccc;\n  padding: 5px 10px;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n/* 테이블 스타일 */\n.companies-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.companies-table th,\n.companies-table td {\n  padding: 12px;\n  text-align: left;\n  border-bottom: 1px solid #ddd;\n}\n\n.companies-table th {\n  background-color: #f9f9f9;\n  font-weight: bold;\n}\n\n.companies-table tr:hover {\n  background-color: #f5f5f5;\n}\n\n.company-link {\n  color: #000;\n  text-decoration: none;\n}\n\n.company-link:hover {\n  text-decoration: underline;\n  font-weight: bold;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
